<template>
    <Listing api="/efp" :title="title" :fields="fields" :filters-schema="filtersSchema" :filters="filters" />
</template>

<script>
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Listing from "@/components/listing";

    export default {
        page: {
            title: "Liste des EFP",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
            PageHeader,
            Listing
        },
        data: () => ({
            title: "Liste des EFP",
            fields: ["code", "nom"],
            filters: {},
            filtersData: {},
            loading: false
        }),
        methods: {
            clearFilters() {
                this.filters = {};
            }
        },
        computed: {
            filtersSchema() {
                return {
                    groups: [
                        {
                            styleClasses: "row align-items-end",
                            fields: [
                                {
                                    type: "b-input",
                                    inputType: "text",
                                    label: "Code",
                                    model: "code",
                                    debounce: 500,
                                    styleClasses: "col font-size-12 text-muted"
                                },
                                {
                                    type: "b-input",
                                    inputType: "text",
                                    label: "Nom",
                                    model: "nom",
                                    debounce: 500,
                                    styleClasses: "col font-size-12 text-muted"
                                },
                                {
                                    type: "submit",
                                    buttonText: "Effacer",
                                    styleClasses: "col-auto",
                                    attributes: {
                                        class: "btn btn-light mb-1"
                                    },
                                    onSubmit: this.clearFilters
                                }
                            ]
                        }
                    ]
                };
            }
        }
    };
</script>
